import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/dashboard/Sidebar";
import Topbar from "@/components/dashboard/Topbar";

export default function DashboardLayout() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    try { const u = JSON.parse(localStorage.getItem("pbh_user") || "null"); if (u) setUser(u); } catch {}
  }, []);
  return (
    <div className="min-h-screen pbh-app-bg flex">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar user={user} />
        <main className="flex-1 px-5 lg:px-7 py-6"><Outlet context={{ user }} /></main>
      </div>
    </div>
  );
}
